import { AtlLogo } from "@/components/store/Brand";

export const fieldCls = "h-11 rounded-lg border-slate-200 bg-white focus-visible:ring-2 focus-visible:ring-[#89CFF0]";
export const primaryBtn = "h-11 w-full rounded-lg bg-[#89CFF0] font-semibold text-slate-900 transition-colors hover:bg-[#74C2EC] disabled:opacity-60";

export default function AuthShell({ title, subtitle, children, testid }) {
  return (
    <div className="flex min-h-screen flex-col bg-gradient-to-b from-sky-50 via-white to-slate-50" data-testid={testid}>
      <div className="mx-auto w-full max-w-7xl px-5 py-6 sm:px-8"><AtlLogo /></div>
      <div className="flex flex-1 items-start justify-center px-5 pb-16 pt-4 sm:items-center sm:pt-0">
        <div className="w-full max-w-md animate-[fadeUp_.45s_ease-out] rounded-2xl border border-slate-200 bg-white p-7 shadow-[0_10px_40px_rgba(137,207,240,0.15)] sm:p-9">
          <h1 className="font-head text-2xl font-extrabold tracking-tight text-slate-900 sm:text-3xl">{title}</h1>
          {subtitle && <p className="mt-2 text-sm leading-relaxed text-slate-600">{subtitle}</p>}
          <div className="mt-7">{children}</div>
        </div>
      </div>
    </div>
  );
}
